import {HttpParams} from '@angular/common/http';
import {environment} from '../../../environments/environment';

export function toHttpParams(params: { [key: string]: string | number | boolean }): HttpParams {
  return Object.getOwnPropertyNames(params)
    .reduce((p, key) => p.set(key, params[key]), new HttpParams());
}

export function url(uri: string): string {
  let base = (environment.serverUrl || '').replace(/\/+$/, ''); // remove trailing slashes
  // Dev convenience: if the configured base points at localhost but the browser is
  // running on an /etc/hosts alias (e.g. twpub.local for testing tenant routing),
  // rewrite the host so the backend's TenantFilter sees the alias too. No-op for
  // prod (which uses a relative URL) or when the browser is on localhost.
  if (typeof window !== 'undefined') {
    const currentHost = window.location.hostname;
    const m = base.match(/^(https?:\/\/)(localhost|127\.0\.0\.1)(:\d+)?$/i);
    if (m && currentHost && currentHost !== 'localhost' && currentHost !== '127.0.0.1') {
      base = `${m[1]}${currentHost}${m[3] ?? ''}`;
    }
  }
  const path = uri.replace(/^\/+/, ''); // remove leading slashes
  return base + '/' + path;
}
